// See https://github.com/JRJurman/rollup-plugin-polyfill/issues/7
// https://github.com/que-etc/resize-observer-polyfill/issues/68
// See also: https://stackoverflow.com/questions/42700396/canvas-element-not-rendering-on-ios-devices
/* eslint-disable no-restricted-globals */
import ResizeObserver from "resize-observer-polyfill";

if (!window.ResizeObserver) {
	window.ResizeObserver = ResizeObserver;
}
